import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            探索知识分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            选择您感兴趣的主题，获取专业的科普知识
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => {
            const colorMap: Record<string, string> = {
              primary: 'bg-primary-100 text-primary-700 border-primary-200',
              secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
              accent: 'bg-accent-100 text-accent-700 border-accent-200',
            };
            const iconColorMap: Record<string, string> = {
              primary: 'text-primary-500',
              secondary: 'text-secondary-500',
              accent: 'text-accent-500',
            };

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex items-start gap-4 p-5 bg-background-50 rounded-lg border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                onMouseEnter={() => setActiveCategory(cat.slug)}
                onMouseLeave={() => setActiveCategory(null)}
              >
                <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${colorMap[cat.color]}`}>
                  <i className={`${cat.icon} text-xl ${iconColorMap[cat.color]}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-foreground-800 mb-1 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                  <p className="text-xs text-foreground-400 mt-2">
                    {cat.articleCount} 篇文章
                  </p>
                </div>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-right-s-line text-foreground-300 transition-transform duration-300 ${activeCategory === cat.slug ? 'translate-x-1' : ''}`}></i>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}